import {
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import {
  AWFTableColumn,
  AWFTableColumnMethods,
} from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../../contributions.enum';

@AWFTableColumn({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_MENU_COLUMN,
  priority: 500,
})
export class DriveCycleTableMenuColumn implements AWFTableColumnMethods {
  id: string = ContributionsEnum.DRIVE_CYCLE_TABLE_MENU_COLUMN;
  priority: number = 500;
  align: TableCellAlign = TableCellAlign.RIGHT;
  type: TableCellTypes = TableCellTypes.MENU_BAR;
  menuId: string = ContributionsEnum.DRIVE_CYCLE_TABLE_MENU_ID;
  width: number = 80;

  render(data: any): Promise<any> {
    return Promise.resolve(data);
  }
}
